import { ButtonGroup, Modal, TextLink } from 'slab'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

const THATCH_BLOG_LINK = 'https://thatch.com/blog/size-minimums-for-ichra-pools-dont-always-apply'

export default function EligibilityExplanationModal ({ open, onOpenChange }: Props) {
  const blogLink = <TextLink href={THATCH_BLOG_LINK} color='purple' target='_blank' rel='noopener noreferrer'>employee classes</TextLink>

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <Modal.Body>
        <Modal.Title size='large'>What does "eligible" mean?</Modal.Title>
        <Modal.Description>
          <div className='flex flex-col gap-4 body-sm'>
            <p>
              People who should receive health benefits through Thatch are called "eligible employees."
            </p>
            <p>
              You can offer different benefits based on {blogLink}, but everyone in a given class must be given the same benefits offer. We currently only support classes by employees who live in the same region.
            </p>
            <p>
              Example 1: let's say you have employees in California and Oregon. Since healthcare costs differ by state, you can accommodate for this difference by giving employees in California a different allowance from those in Oregon.
            </p>
            <p>
              Example 2: if you only offer benefits to full-time employees, all full-time employees have to be marked eligible, but you don't need to include any part-time employees. (But if you include one part-time employee, you have to include all of them!)
            </p>
          </div>
        </Modal.Description>
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup align='right'>
          <Modal.Button variant='primary' size='large'>
            Close
          </Modal.Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  )
}
